<template>
  <div class="row">
    <div class="col-12">
      <div v-html="text" class="block-text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextBlock",
  props: {
    header: Object,
    text: String,
  },
};
</script>

<style scoped lang="scss">
::v-deep .block-text {
  & p > img {
    width: 100%;
  }
}
</style>
